import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { analytics } from 'core/analytics';
import { FourOhFour } from 'apps/fourOhFour/index';

import { SubPageTextIndicator } from 'legacyComponents/indicators';
import DocumentHead from 'legacyComponents/documentHead';
import { SubPage } from 'legacyComponents/layout/subPage';
import { SubPageStats } from 'legacyComponents/layout/subPageStats';
import { Button } from 'components';

import { PostPageAppManager } from 'apps/aggregator/postPage/appManager';
import { PostPageContent } from 'apps/aggregator/views/postPageContent';

// import FormActionButton from 'libs/forms/views/formActionButton';
// import { Action } from 'apps/components/header/header.styled';
import Header from 'apps/components/header/header';

import { withNamespaces, Trans } from 'react-i18next';

@withNamespaces()
@observer
export class PostPage extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new PostPageAppManager(null, this.props);
  }

  upvotePost = () => {
    const post = this.appManager.postPage;
    post.Upvote();
    analytics.sendEvent('upvoted-post');
  };

  downvotePost = () => {
    const post = this.appManager.postPage;
    post.Downvote();
    analytics.sendEvent('downvoted-post');
  };

  render() {
    const { t } = this.props;

    if (this.appManager.queries.get('postPage').notFound) {
      return <FourOhFour type='Post Page' />;
    }
    const post = this.appManager.postPage;
    if (this.appManager.loading) {
      return (
        <SubPage backButton>
          <SubPageTextIndicator />
          <SubPageStats loading />
        </SubPage>
      );
    }

    let actionButton = (
      <ButtonStyled
        text={<Trans>Upvote</Trans>}
        size='small'
        onClick={this.upvotePost}
      />
    );
    if (post.isUpvoted) {
      actionButton = (
        <ButtonStyled
          text={<Trans>Undo upvote</Trans>}
          variant='destructive'
          size='small'
          onClick={this.downvotePost}
        />
      );
    }

    // const actions = post.editing && [
    //   <Action key='cancelAction'>
    //     <FormActionButton
    //       formStore={post.editFormStore}
    //       buttonHandler={post.Cancel}
    //       buttonText={'Cancel'}
    //       variant={'destructive'}
    //     />
    //   </Action>,
    //   <Action key='saveAction'>
    //     <FormActionButton
    //       formStore={post.editFormStore}
    //       buttonHandler={post.Save}
    //       buttonText={'Save'}
    //       buttonTextPosting={'Saving...'}
    //     />
    //   </Action>,
    // ];

    return (
      <main>
        <Header />
        <DocumentHead title={post.title} description={post.msg} />
        <SubPage
          title={
            post.isQuestion ? t('Question and Answers') : t('Post Discussion')
          }
          backButton
        >
          <PostPageContent post={post} />
          <SubPageStats
            tags={post.tags}
            participants={post.commenters}
            button={actionButton}
          />
        </SubPage>
      </main>
    );
  }
}

// FIXME: Move these styles to its styled file pending from post page
const ButtonStyled = styled(Button)`
  margin: ${props => `${props.theme.spacing.default} auto`};
  display: block;
`;

PostPage.propTypes = {
  routerStore: PropTypes.object,
  t: PropTypes.func,
};
